module.exports = __webpack_public_path__ + "static/media/cat-is-wrong.72934c09.mp3";